import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import moment from "moment";
import { get } from "axios";
const mapStateToProps = (state, ownProps) => {
  const appraisee = state.appraisalSlice.appraisee;
  const year = state.appraisalSlice.year;

  // console.log(state.appraisalSlice);
  return { appraisee, year };
};

const AppraisalFormHeader = (props) => {
  const [pic, setPic] = useState("");
  const { appraisee } = props;

  const { userid, fullname, date_joined, position } = appraisee;

  useEffect(() => {
    let isMounted = true;
    // console.log(userid);
    // console.log(appraisee);
    if (userid === undefined) return;
    get(
      "https://eleave.hslnet.my/apiv2/public/index.php/employeephoto/" + userid
    )
      .then((res) => {
        if (isMounted) {
          // setPic(res.data.photo);
          if (res.data !== "") {
            setPic(res.data.photo);
          }
          else {
            setPic("data:image/jpeg;base64,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");
          }
        }
      })
      .catch((e) => {});

    return () => {
      isMounted = false;
    };
  }, [userid]);

  return (
    <div className="card">
      <div className="card-body">
        <div className="row">
          <div className="col-12 col-lg-9">
            <div className="form-group row">
              <label className="col-6 col-md-3 col-form-label">
                Staff Name
              </label>
              <div className="col-6 col-md-9">
                <input
                  type="text"
                  className="form-control"
                  readOnly
                  value={fullname}
                ></input>
              </div>
            </div>

            <div className="form-group row">
              <label className="col-6 col-md-3 col-form-label">Position</label>
              <div className="col-6 col-md-9">
                <input
                  type="text"
                  className="form-control"
                  readOnly
                  value={position}
                ></input>
              </div>
            </div>
            {/* <div className="form-group row">
              <label className="col-6 col-md-3 col-form-label">
                Date joined
              </label>
              <div className="col-6 col-md-9">
                <input
                  type="text"
                  className="form-control"
                  readOnly
                  // value={moment(date_joined).format("d MMM yyyy")}
                  value={date_joined}
                ></input>
              </div>
            </div> */}
          </div>
          <div className="d-none d-lg-block col-lg-3">
            {pic && (
              <img
                alt="xx"
                src={pic}
                style={{ borderRadius: "50%", width: "8em" }}
              />
            )}
          </div>
        </div>
      </div>
      <div className="card-body">
        <h6>OBJECTIVES</h6>
        <div>
          The purpose of the evaluation is to provide constructive feedback to
          staff and to formulate a basis for salary reviews and bonuses. It
          should assist both the staff member and his/her supervisor in
          identifying areas of improvement or competency gaps which can be
          addressed.
        </div>
      </div>
      <div className="card-body">
        <h6>INSTRUCTIONS</h6>
        <div>
          This performance evaluation must be completed honestly and objectively
          by the relevant head of department or supervisor. Each criterion is to
          be rated using the scale referenced below:
        </div>
        <div style={{ padding: "1em" }}>
          <table className="table table-scoreboard">
            <thead>
              <tr>
                <th style={{ minWidth: "10vw" }}>Scale</th>
                <th style={{ minWidth: "10vw" }}>Rating</th>
                <th style={{ minWidth: "10vw" }}>Remark</th>
                <th>Competency Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span style={{ fontSize: "0.5em" }}>
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                  </span>
                </td>
                <td>100</td>
                <td>Excellent</td>
                <td rowSpan={2}>No action required</td>
              </tr>
              <tr>
                <td>
                  <span style={{ fontSize: "0.5em" }}>
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                  </span>
                </td>
                <td>85</td>
                <td>Good</td>
              </tr>
              <tr>
                <td>
                  <span style={{ fontSize: "0.5em" }}>
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                  </span>
                </td>
                <td>70</td>
                <td>Satisfactory</td>
                <td rowSpan={2}>Optional training can be considered</td>
              </tr>
              <tr>
                <td>
                  <span style={{ fontSize: "0.5em" }}>
                    <FontAwesomeIcon icon={faStar} />
                    <FontAwesomeIcon icon={faStar} />
                  </span>
                </td>
                <td>50</td>
                <td>Fair</td>
              </tr>
              <tr>
                <td>
                  <span style={{ fontSize: "0.5em" }}>
                    <FontAwesomeIcon icon={faStar} />
                  </span>
                </td>
                <td>30</td>
                <td rowSpan={2}>Poor</td>
                <td rowSpan={2}>
                  Performance below expectation and competency gap exists.
                  Relevant training or actions may be considered
                </td>
              </tr>
              <tr>
                <td>
                  <span style={{ fontSize: "0.5em" }}></span>
                </td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          The appraiser must assess the staff member according to his/her
          position and level of experience and against his/her job descriptions.
          The appraiser should also bear in mind that the HSL Group expects
          superior performances from its staff. Specific examples should be
          provided to support assessments, particularly for ratings{" "}
          <b>5 stars and no stars</b>. It is essential that this evaluation be
          discussed with the staff member for development and improvement.
        </div>
      </div>
    </div>
  );
};
export default connect(mapStateToProps, null)(AppraisalFormHeader);
